import appStore from '@stores/appStore'
import assistantStore from '@stores/assistantStore'
import { observer } from 'mobx-react'
import { useEffect } from 'react'

import { startAssistantBridge } from './assistantBridge'
import AssistantDrawer from './AssistantDrawer'
import { navigateHere } from './assistantNavigation'

/**
 * The AI Assistant drawer and its global shortcut (Ctrl+K / Cmd+K). It is
 * opened from the Quick Action menu ("AI Assistant", under Send Feedback).
 * Rendered only when the tenant feature Application:AIAssistant is on (inside
 * the AI Service master switch, as the backend requires) and the user's role is
 * in the assistant's audience for this tenant.
 */
const AssistantWidget = () => {
  const enabled = appStore.isAssistantEnabled

  useEffect(() => {
    if (!enabled) {
      return
    }
    const onKeyDown = (e: KeyboardEvent) => {
      // Rich-text editors (CKEditor) use Ctrl+K for "insert link" — do not steal it there.
      const target = e.target as HTMLElement | null
      if (e.defaultPrevented || target?.isContentEditable) {
        return
      }
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        assistantStore.toggle()
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [enabled])

  // Links clicked in the Assistant's own tab (/view/assistant) navigate this app.
  useEffect(() => {
    if (!enabled) {
      return
    }
    return startAssistantBridge(navigateHere)
  }, [enabled])

  if (!enabled) {
    return null
  }

  return <AssistantDrawer />
}

export default observer(AssistantWidget)
